var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChannelCouponDialog',{attrs:{"is-show":_vm.isShow,"coupon-id":_vm.couponId,"coupon-tag-text":_vm.channelTagText},on:{"onExchPrize":_vm.onExchPrize,"onClose":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }